import React from 'react';
import {MasterLayout} from 'layout';
import { DanhSachThongKeGiamSatDonCu } from 'modules/theo-doi-giam-sat';

export default class DanhSachThongKeGiamSatDonCuPage extends React.Component {
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhSachThongKeGiamSatDonCu params={this.props.params}/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/theo-doi-giam-sat/DanhSachThongKeGiamSatDonCuPage.jsx